import React from 'react';
import { render } from '@testing-library/react';
import { OptionList } from './OptionList';

describe('OptionList', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<OptionList
				multiple
				options={[
					{
						text: 'dog.png',
						value: 54,
						className: 'singleOptionClassName',
					},
					{
						text: 'cat.jpg',
						value: 5444,
					},
					{
						text: 'house.tif',
						value: 544,
					},
					{
						text: 'worksheet.xls',
						value: 541,
					},
					{
						text: 'README.md',
						value: 54441,
					},
					{
						text: 'todo.txt',
						value: 5441,
					},
				]}
				optionClassName="customOptionClassName"
				data-auto-sel="automation-selector"
			/>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
